<template>
  <div>
    <NavigationDrawer app></NavigationDrawer>
    <v-main>
      <v-container fluid class="container-fluid" style="padding: 0 !important;">
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-footer app>
      <LayoutFooter />
    </v-footer>
  </div>
</template>

<script>
import LayoutFooter from '../../views/admin/layout/LayoutFooter'
import NavigationDrawer from '../../views/admin/layout/NavigationDrawer'
export default {
  name: 'Layout',
  components: { LayoutFooter, NavigationDrawer }
}
</script>
<style scoped>
  .main {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .container-fluid{
    width: 100% !important;
    padding: 0;
    margin: 0;
  }
</style>
